/** @jsx h */
/* eslint-disable react/prop-types */
import { h, render, Component } from 'preact';

function extractImages(galleryDomNode) {
    var thumbNodes = galleryDomNode.querySelectorAll('.gallery__thumb');

    return {
        images: Array.prototype.map.call(thumbNodes, (thumbNode) => {
            return {
                thumbSrc: thumbNode.src,
                // TODO: srcset
                fullSrc: thumbNode.parentNode.href,
                title: thumbNode.title,
            };
        }),
        id: galleryDomNode.id,
        elem: galleryDomNode,
    };
}

function extractGallery(id) {
    var elem = document.getElementById(id);
    return extractImages(elem);
}

function clearDom(elem) {
    while (elem.firstChild) {
        elem.removeChild(elem.firstChild);
    }
}

class Gallery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            busy: false,
        };
    }

    startLoading(index) {
        var image = this.props.images[index];
        var img = new Image();
        img.onload = () => {
            this.setState({
                currentIndex: index,
                busy: false,
            });
        };
        img.src = image.fullSrc;
    }

    switchTo(index) {
        var { images } = this.props;
        index = index % images.length;
        if (index < 0) index = images.length - 1;
        this.setState({
            busy: true,
        });
        this.startLoading(index);
    }

    nextImage = (e) => {
        var { currentIndex, busy } = this.state;
        e.preventDefault();
        if(busy) return;
        this.switchTo(currentIndex + 1);
    }

    previousImage = (e) => {
        var { currentIndex, busy } = this.state;
        e.preventDefault();
        if(busy) return;
        this.switchTo(currentIndex - 1);
    }

    render({images}, {currentIndex, busy}) {
        var currentImage = images[currentIndex];
        var classes = ['gallery__main'];
        if(busy) {
            classes.push('gallery__main--busy');
        }
        return (
            <div className='gallery'>
                <div className={classes.join(' ')}>
                    <img className='gallery__main-image' src={currentImage.fullSrc} />
                    <div className='gallery__overlay gallery__overlay--left' onClick={this.previousImage}>
                        <i className='fa fa-chevron-left gallery__prev'></i>
                    </div>
                    <div className='gallery__overlay gallery__overlay--right' onClick={this.nextImage}>
                        <i className='fa fa-chevron-right gallery__next'></i>
                    </div>
                </div>
                <p className='gallery__title'>{currentImage.title}</p>
                <div className='gallery__thumbs'>{this.renderThumbs()}</div>
            </div>
        );
    }

    renderThumbs() {
        var { images } = this.props;

        return images.map((image, idx) => {
            return (
                <img src={image.thumbSrc} key={idx} className='gallery__thumb' onClick={() => this.switchTo(idx)} />
            );
        });
    }
}

export function init(id) {
    var gallery = extractGallery(id);
    clearDom(gallery.elem);
    render(<Gallery images={gallery.images} />, gallery.elem);
}

//import('preact/devtools');



// WEBPACK FOOTER //
// ./js/viewGallery/index.js